import { render, staticRenderFns } from "./TourTrigger.vue?vue&type=template&id=bea10112&scoped=true"
import script from "./TourTrigger.vue?vue&type=script&lang=js"
export * from "./TourTrigger.vue?vue&type=script&lang=js"
import style0 from "./TourTrigger.vue?vue&type=style&index=0&id=bea10112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea10112",
  null
  
)

export default component.exports